import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Music2 } from "lucide-react";
import { useI18n } from "../lib/i18n";

const SOCIALS = [
  { Icon: Instagram, label: "Instagram", url: "https://www.instagram.com/motravaymu/", color: "bg-gradient-to-tr from-amber-500 via-rose-500 to-fuchsia-600" },
  { Icon: Facebook, label: "Facebook", url: "https://www.facebook.com/motravay.mu", color: "bg-[#1877F2]" },
  { Icon: Linkedin, label: "LinkedIn", url: "https://www.linkedin.com/company/motravay/", color: "bg-[#0A66C2]" },
  { Icon: Music2, label: "TikTok", url: "https://www.tiktok.com/@motravay", color: "bg-black" },
];

export default function Footer() {
  const { t, lang } = useI18n();
  return (
    <footer className="bg-black text-slate-400 mt-20 border-t border-slate-800" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <img src="/motravay-logo.png" alt="Motravay" className="h-10 w-auto object-contain" data-testid="footer-logo" />
          <p className="text-sm mt-3 leading-relaxed">{t("footer.tagline")}</p>
          <div className="mt-5 flex gap-2">
            {SOCIALS.map(({ Icon, label, url, color }) => (
              <a key={label} href={url} target="_blank" rel="noreferrer" aria-label={label} data-testid={`footer-social-${label.toLowerCase()}`} className={`h-9 w-9 rounded-full text-white flex items-center justify-center ${color} hover:opacity-90`}>
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h5 className="text-white text-xs font-semibold uppercase tracking-[0.2em]">{t("footer.candidates")}</h5>
          <ul className="text-sm mt-4 space-y-2.5">
            <li><Link to="/jobs" data-testid="footer-jobs" className="hover:text-[#1A8FE3] transition-colors">{t("footer.searchJobs")}</Link></li>
            <li><Link to="/register" data-testid="footer-register" className="hover:text-[#1A8FE3] transition-colors">{t("footer.createAccount")}</Link></li>
            <li><Link to="/login" data-testid="footer-login" className="hover:text-[#1A8FE3] transition-colors">{t("nav.login")}</Link></li>
            <li><Link to="/inbox" className="hover:text-[#1A8FE3] transition-colors">{lang === "fr" ? "Boîte de réception" : "Inbox"}</Link></li>
          </ul>
        </div>
        <div>
          <h5 className="text-white text-xs font-semibold uppercase tracking-[0.2em]">{t("footer.recruiters")}</h5>
          <ul className="text-sm mt-4 space-y-2.5">
            <li><Link to="/register?role=employer" data-testid="footer-post-job" className="hover:text-[#1A8FE3] transition-colors">{t("footer.postJobLink")}</Link></li>
            <li><Link to="/pricing" data-testid="footer-pricing" className="hover:text-[#1A8FE3] transition-colors">{t("footer.pricing")}</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="hover:text-[#1A8FE3] transition-colors">{t("footer.contact")}</Link></li>
          </ul>
        </div>
        <div>
          <h5 className="text-white text-xs font-semibold uppercase tracking-[0.2em]">{t("footer.company")}</h5>
          <ul className="text-sm mt-4 space-y-2.5">
            <li><Link to="/about" data-testid="footer-about" className="hover:text-[#1A8FE3] transition-colors">{t("footer.about")}</Link></li>
            <li><Link to="/terms" data-testid="footer-terms" className="hover:text-[#1A8FE3] transition-colors">{t("footer.terms")}</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-[#1A8FE3] transition-colors">{t("footer.privacy")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-4 text-center text-xs">© {new Date().getFullYear()} Motravay — {lang === "fr" ? "Le job board de Maurice." : "The job board of Mauritius."} {lang === "fr" ? "Tous droits réservés." : "All rights reserved."}</div>
    </footer>
  );
}
